module.exports = __webpack_public_path__ + "img/broadcast-work-icon2.40da9452.png";